module.exports = __webpack_public_path__ + "media/images/new-ui-images/transaction-46375f5c8ff6a20e30243e801cfdac5a.svg";